<template>
  <div class="p-5 bg-gray-100 rounded m-2">
    <p class="text-center font-bold w-full block" v-text="i18n.title"></p>
    <div class="flex justify-center py-3">
      <button
        class="button button-base action"
        v-text="i18n.go"
        @click="toggle"
        v-if="mode === 'preregister'"
      ></button>
    </div>
    <div class="" v-if="mode === 'register'">
      <form @submit.prevent="register">
        <div class="py-1">
          <span
            class="relative inline-block mr-6 cursor-pointer"
            v-for="(item, index) in i18n.gender.options"
            :key="item"
          >
            <input
              name="gender"
              type="radio"
              :id="index"
              :value="index"
              v-model="form.gender"
              class="opacity-0 absolute h-6 z-0"
              @change="form.errors.clear('gender')"
              required
            />
            <label
              :for="index"
              class="relative flex items-center cursor-pointer"
            >
              <span
                class="flex justify-center items-center w-5 h-5 inline-block mr-3 rounded-full border border-grey"
                ><span class="w-2 h-2 inline-block rounded-full"></span
              ></span>
              {{ item }}
            </label>
          </span>
          *

          <span class="help danger">
            <span
              v-if="form.errors.has('gender')"
              v-text="form.errors.get('gender')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="firstname" v-text="i18n.firstname.label + ' *'"></label>
          <input
            id="firstname"
            v-model="form.firstname"
            :class="{ danger: form.errors.has('firstname') }"
            @change="form.errors.clear('firstname')"
            required
          />
          <span class="help danger">
            <span
              v-if="form.errors.has('firstname')"
              v-text="form.errors.get('firstname')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="lastname" v-text="i18n.lastname.label + ' *'"></label>
          <input
            id="lastname"
            v-model="form.lastname"
            :class="{ danger: form.errors.has('lastname') }"
            @change="form.errors.clear('lastname')"
            required
          />
          <span class="help danger">
            <span
              v-if="form.errors.has('lastname')"
              v-text="form.errors.get('lastname')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="email" class="flex justify-between">
            <span v-text="i18n.email.label + ' *'"></span>
            <span v-text="i18n.email.help" class="text-sm text-gray-700"></span>
          </label>
          <input
            id="email"
            v-model="form.email"
            :class="{ danger: form.errors.has('email') }"
            @change="form.errors.clear('email')"
            required
          />
          <span class="help danger">
            <span
              v-if="form.errors.has('email')"
              v-text="form.errors.get('email')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="password" class="flex justify-between">
            <span v-text="i18n.password.label + ' *'"></span>
            <span
              v-text="i18n.password.help"
              class="text-sm text-gray-700"
            ></span>
          </label>
          <input
            id="password"
            type="password"
            v-model="form.password"
            :class="{ danger: form.errors.has('password') }"
            @change="form.errors.clear('password')"
            required
          />
          <span class="help danger">
            <span
              v-if="form.errors.has('password')"
              v-text="form.errors.get('password')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="application" class="flex justify-between">
            <span v-text="i18n.application.label + ' *'"></span>
          </label>
          <select
            name="application"
            id="application"
            v-model="form.application"
            :class="{ danger: form.errors.has('application') }"
            @change="form.errors.clear('application')"
            required
          >
            <option
              disabled
              value=""
              v-text="i18n.application.choose"
              class="text-gray-700"
            ></option>
            <option
              v-for="(application, index) in applications"
              :key="application"
              :value="index"
              v-text="application"
            ></option>
          </select>
          <span class="help danger">
            <span
              v-if="form.errors.has('application')"
              v-text="form.errors.get('application')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="phone_number" class="flex justify-between">
            <span v-text="i18n.phone.label + ' *'"></span>
            <span v-text="i18n.phone.help" class="text-sm text-gray-700"></span>
          </label>
          <div class="control flex-col">
            <div
              class="phone-input flex item-center justify-start w-full border border-gray-200 bg-white rounded hover:border-gray-300"
            >
              <div
                class="bg-action text-black flex items-center rounded-left border border-action rounded-r-none rounded w-24"
              >
                <label for="phone_code" class="pl-2 pr-3 text-center">+</label>
                <input
                  class="rounded-0 border-none bg-white h-8"
                  placeholder=""
                  maxlength="4"
                  id="phone_code"
                  type="tel"
                  name="phone_code"
                  v-model="form.phone_code"
                  @change="form.errors.clear('phone_code')"
                  style="
                    -webkit-box-shadow: 0 0 0 50px #fff inset;
                    width: 2.8rem;
                  "
                  required
                />
              </div>
              <input
                class="number code rounded-0 border-none"
                pattern="^[0-9\. \(\)_+-]+$"
                placeholder=""
                id="phone_number"
                type="text"
                name="phone_number"
                v-model="form.phone_number"
                @change="form.errors.clear('phone_number')"
                required
              />
            </div>
          </div>
          <span class="help danger flex justify-between w-full">
            <span
              v-if="form.errors.has('phone_code')"
              v-text="form.errors.get('phone_code')"
            ></span>
            <span
              v-if="form.errors.has('phone_number')"
              v-text="form.errors.get('phone_number')"
            ></span>
          </span>
        </div>

        <div class="py-1">
          <label for="captcha" class="flex justify-between">
            <span v-text="i18n.captcha.label + ' *'"></span>
            <span
              v-text="i18n.captcha.help"
              class="text-sm text-gray-700"
            ></span>
          </label>
          <div class="control flex-col">
            <div
              class="captcha-input flex item-center justify-start w-full border border-gray-200 hover:border-gray-300 bg-white rounded"
            >
              <label for="captcha" class="img bg-action w-30 flex">
                <img
                  class="cursor-pointer img bg-action px-2 flex justify-center items-center"
                  alt="error: reload me"
                  title="@lang('v2/auth.register.captcha.title')"
                  :src="i18n.captcha.src"
                  ref="captcha"
                  @click="refreshCaptcha"
                />
              </label>
              <input
                class="border-none"
                id="captcha"
                type="text"
                v-model="form.captcha"
                @change="form.errors.clear('captcha')"
                required
              />
            </div>
            <span class="help danger">
              <span
                v-if="form.errors.has('captcha')"
                v-text="form.errors.get('captcha')"
              ></span>
            </span>
          </div>
        </div>

        <div class="py-1">
          <input
            type="checkbox"
            id="student"
            value="1"
            class="hidden"
            v-model="form.student"
          />
          <label for="student" class="flex items-center cursor-pointer">
            <span
              class="flex justify-center items-center w-5 h-5 inline-block mr-3 rounded border border-grey"
            >
              <span class="text-xs">
                <font-awesome-icon icon="check"></font-awesome-icon>
              </span>
            </span>
            {{ i18n.student.label }}
          </label>
          <p class="text-sm" v-text="i18n.student.help"></p>
        </div>

        <div class="flex justify-center py-3">
          <button
            type="submit"
            class="button button-base action"
            v-text="i18n.go"
          ></button>
        </div>

        <p
          class="text-sm text-gray-900 text-justify"
          v-text="i18n.cnil.text"
        ></p>
      </form>
    </div>
  </div>
</template>

<script>
import { Form } from "../Utilities/Form";
import ErrorModal from "./ErrorRegistrationModal";
import CreatingAccountModal from "./CreatingAccountModal";

export default {
  props: ["i18n", "registered", "applications", "route"],
  components: {},
  mixins: [],
  data: function () {
    return {
      mode: "preregister",
      form: new Form({
        gender: "",
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        student: 0,
        application: "",
        phone_code: "",
        phone_number: "",
        lang: this.$route.params.locale,
        captcha: "",
      }),
    };
  },
  methods: {
    toggle() {
      if (this.mode === "preregister") {
        this.$emit("mode-register");
        this.mode = "register";
      } else {
        //this.$emit('mode-preregister');
        this.mode = "preregister";
      }
    },

    register() {
      this.form.errors.clear();
      this.showCreatingAccountModal();
      if (window.google_analytics_pageview) {
        window.google_analytics_pageview("/form-submit/login/register");
      }
      this.form
        .post(this.route)
        .then(() => {
          if (window.google_analytics_pageview) {
            window.google_analytics_pageview("/form-submit/login/registred");
          }
          this.$modal.hide("creating_account_modal");
          this.$emit("logged-in");
        })
        .catch(() => {
          setTimeout(() => {
            this.$modal.hide("creating_account_modal");
          }, 500);
          this.refreshCaptcha();
          this.form.captcha = "";
          if (this.form.errors.errors === undefined) {
            this.showErrorModal();
          }
        });
    },

    refreshCaptcha() {
      this.$refs.captcha.src = this.i18n.captcha.src + "?" + Math.random();
      //this.form.errors.clear('captcha');
    },

    showCreatingAccountModal() {
      this.$modal.show(
        CreatingAccountModal,
        {
          message: this.i18n.creating,
        },
        {
          name: "creating_account_modal",
          scrollable: false,
          clickToClose: false,
          adaptive: true,
          resizable: true,
          //width: 'auto',
          height: "auto",
          classes: "bg-white w-full rounded xl:max-w-3xl",
          width: 760,
        }
      );
    },

    showErrorModal() {
      this.$modal.show(
        ErrorModal,
        {
          i18n: this.registered.error,
        },
        {
          name: "error_registration_modal",
          scrollable: false,
          clickToClose: false,
          adaptive: true,
          resizable: true,
          height: "auto",
          classes:
            "bg-red-100 border-red-200 border rounded text-red-800 shadow-md w-full xl:max-w-3xl",
          width: 760,
        }
      );
    },
  },
  computed: {},
  mounted() {},
};
</script>
